import * as Yup from "yup";

export const switchCurrencySchema = (intl) => {
  return Yup.object().shape({
    confirmPassword: Yup.string()
      .nullable(false)
      .required(intl.formatMessage({ id: "passwordRequired" })),
  });
};
